<div class="modal">
  <div class="content">
    <div class="modal-header">
      <span>{{'teams.CALL_NAME_LABEL' | transloco}}</span>
      <span>{{'teams.HIGHEST_SCORE' | transloco}}</span>
    </div>
    <div class="modal-body">
      <div *ngIf="callDetails.length > 0">
        <div *ngFor="let call of callDetails">
          <div class="call-detail" *ngIf="call.highestScore > 0">
            <span>{{ call.callName }}</span>
            <span class="score">{{ call.highestScore | localeNumber:1:true }}</span>
            <span class="total-score">/5</span>
          </div>
          <div class="call-detail" *ngIf="call.highestScore === 0">
            <span>{{ call.callName }}</span>
            <span class="not-started">{{'teams.NOT_STARTED' | transloco}}</span>
          </div>
        </div>
      </div>
      <div *ngIf="callDetails.length === 0">
        <div class="call-detail" *ngFor="let call of summaryCalls">
          <span>{{ call.name }}</span>
          <span class="not-started">{{'teams.NOT_STARTED' | transloco}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="button">
    <div class="cancel-icon" (click)="close()"></div>
  </div>
</div>
